import { FC, SVGProps } from 'react';
import { ReactComponent as JourneyIcon } from '../../../assets/icons/Navbar/journey.svg';
import { ReactComponent as MessagesIcon } from '../../../assets/icons/Navbar/messages.svg';
import { ReactComponent as AppointmentsIcon } from '../../../assets/icons/Navbar/appointments.svg';
import { ReactComponent as DashboardIcon } from '../../../assets/icons/Navbar/dashboard.svg';
import { ReactComponent as ResultsIcon } from '../../../assets/icons/Navbar/results.svg';
import { ReactComponent as DocumentsIcon } from '../../../assets/icons/Navbar/documents.svg';
import { ReactComponent as ResourcesIcon } from '../../../assets/icons/Navbar/resources.svg';
import { ReactComponent as InvoicesIcon } from '../../../assets/icons/Navbar/file-invoice-dollar-solid.svg';

export type MenuItem = {
  id: string;
  label: string;
  icon?: FC<SVGProps<SVGSVGElement>>;
  to?: string;
  notificationKey?: string;
  order: number;
};

export const menuItems: Array<MenuItem> = [
  { id: 'dashboard', label: 'Dashboard', icon: DashboardIcon, to: '/', order: 0 },
  {
    id: 'appointment',
    label: 'Appointments',
    icon: AppointmentsIcon,
    to: '/appointments',
    order: 1
  },
  {
    id: 'results',
    label: 'Results',
    icon: ResultsIcon,
    to: '/results',
    order: 3
  },
  {
    id: 'journey',
    label: 'My Journey',
    icon: JourneyIcon,
    to: '/my-journey',
    order: 4
  },
  {
    id: 'documents',
    label: 'Documents',
    icon: DocumentsIcon,
    to: '/documents',
    order: 5
  },
  {
    id: 'resources',
    label: 'Resources',
    icon: ResourcesIcon,
    to: '/resources',
    order: 7
  },
  {
    id: 'invoices',
    label: 'Billing',
    icon: InvoicesIcon,
    to: '/invoices',
    order: 6
  }
];

export const messagesItem = {
  id: 'messages',
  label: 'Messages',
  icon: MessagesIcon,
  to: '/messages',
  notificationKey: 'unreadMessagesCount',
  order: 2
};

export const comingSoonMenuItems: Array<MenuItem> = [messagesItem];
